export default "__VITE_ASSET__DMmV2pix__"